import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'

function getDoneWorksAllHandMadeWorks(companyId, query) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS,
		dtConfig[ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS][ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS].GET_DONE_WORKS_ALL_HAND_MADE_WORKS],
		{
			urlParams: {
				companyId,
			},
			params: query,
		}
	)
}

export default {
	getDoneWorksAllHandMadeWorks,
}
